__turbopack_context__.v({
  "gear_icon": "SHVFDa_gear_icon",
  "is_open": "SHVFDa_is_open",
  "my_station_icon": "SHVFDa_my_station_icon",
  "next_icon": "SHVFDa_next_icon",
  "station_button": "SHVFDa_station_button",
  "station_menu": "SHVFDa_station_menu",
  "station_menu_change_station_button": "SHVFDa_station_menu_change_station_button",
  "station_menu_description": "SHVFDa_station_menu_description",
  "station_menu_explore_more_link": "SHVFDa_station_menu_explore_more_link",
  "station_menu_info": "SHVFDa_station_menu_info",
  "station_menu_info_title": "SHVFDa_station_menu_info_title",
  "station_menu_inner": "SHVFDa_station_menu_inner",
  "station_menu_item": "SHVFDa_station_menu_item",
  "station_menu_link": "SHVFDa_station_menu_link",
  "station_menu_links": "SHVFDa_station_menu_links",
  "station_menu_logo": "SHVFDa_station_menu_logo",
  "station_menu_more_from_station": "SHVFDa_station_menu_more_from_station",
});
